const Counter = () => {
    return (
        <div className="Counter">
            <img
                alt="visitors"
                src="https://visitor-badge.laobi.icu/badge?page_id=honux77.github.io-earthbound0-ost"
            />
        </div>
    );
}

export default Counter;